import React, { useState, useRef } from "react";
import { MoreHoriz } from "@material-ui/icons";
import useOutsideClick from "../Hooks/useOutsideClick";
import Dialog, { DialogOptions } from "~/components/Dialog";

const ActionsMenu = ({ options = {} }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div style={{ position: "relative" }}>
      <button className="btn btn--sqr" onClick={handleOpen}>
        <MoreHoriz style={{ fontSize: 14 }} />
      </button>
      {isOpen && (
        <Dialog setOpen={setIsOpen} dialogClasses="dialog--right">
          <DialogOptions>
            {options.map((o) => {
              return (
                <div
                  key={o.id}
                  className="dialog__item"
                  onClick={() => {
                    o.action();
                    handleOpen();
                  }}
                >
                  {o.label}
                </div>
              );
            })}
          </DialogOptions>
        </Dialog>
      )}
    </div>
  );
};

export default ActionsMenu;
